// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"41c6b98f","349":"1976cd4a","416":"92ee00ac","445":"39d50427","544":"d136e2d9","568":"375fcfb5"}[chunkId] + ".chunk.js";
};